import { render, staticRenderFns } from "./ProjectUser.vue?vue&type=template&id=45ab1e5f"
import script from "./ProjectUser.vue?vue&type=script&lang=js"
export * from "./ProjectUser.vue?vue&type=script&lang=js"
import style0 from "./ProjectUser.vue?vue&type=style&index=0&id=45ab1e5f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports